import React, { useReducer } from 'react';

const RootContext = React.createContext();

export const TYPES = {
  SET_SIDEBAR_STATE: 'sidebar/SET_SIDEBAR_STATE',
  SET_NAVBAR_STATE: 'navbar/SET_NAVBAR_STATE',
  AEP_SET_ACTIVE: 'aep/SET_ACTIVE',
  TARGET_SET_ACTIVE: 'target/SET_ACTIVE',
  ACS_SET_ACTIVE: 'acs/SET_ACTIVE',
  ACC_SET_ACTIVE: 'acc/SET_ACTIVE',
  GENERIC_SET_ACTIVE: 'generic/SET_ACTIVE',
  THIRD_PARTY_PRODUCTS_SET_ACTIVE: 'thirdPartyProducts/SET_ACTIVE',
  THIRD_PARTY_PRODUCTS_UPDATED: 'thirdPartyProducts/UPDATED'
};

export const initialState = {
  currentUser: null,
  configurations: [],
  sidebar: {
    isOpen: false,
    content: null
  },
  navbar: {
    isOpen: false,
    content: null
  },
  activeAEP: {},
  activeSidebarItem: null,
  activeThirdPartyProduct: {},
  fetchThirdPartyProducts: false
};

// This is equivalent to standard reducer's switch-case statement but more condensed, readable and separable
const handlers = {};

handlers[TYPES.SET_SIDEBAR_STATE] = (state, action) => ({
  ...state,
  sidebar: { isOpen: action.isOpen, content: action.content }
});

handlers[TYPES.SET_NAVBAR_STATE] = (state, action) => ({
  ...state,
  navbar: { isOpen: action.isOpen, content: action.content }
});

handlers[TYPES.AEP_SET_ACTIVE] = (state, action) => ({
  ...state,
  activeAEP: action.aep
});

handlers[TYPES.TARGET_SET_ACTIVE] = (state, action) => ({
  ...state,
  activeTarget: action.target
});

handlers[TYPES.ACS_SET_ACTIVE] = (state, action) => ({
  ...state,
  activeACS: action.acs
});

handlers[TYPES.ACC_SET_ACTIVE] = (state, { acc }) => ({
  ...state,
  activeACC: acc
});

handlers[TYPES.GENERIC_SET_ACTIVE] = (state, action) => ({
  ...state,
  activeSidebarItem: action.activeSidebarItem
});

handlers[TYPES.THIRD_PARTY_PRODUCTS_SET_ACTIVE] = (state, action) => ({
  ...state,
  activeThirdPartyProduct: action.thirdPartyProduct
});

handlers[TYPES.THIRD_PARTY_PRODUCTS_UPDATED] = (state, action) => ({
  ...state,
  fetchThirdPartyProducts: action.fetchThirdPartyProducts
});

// Reducer factory to enable enhanced syntax above
const reducerFactory =
  (initialState, handlers) =>
  (state = initialState, action) =>
    handlers && handlers[action.type]
      ? handlers[action.type](state, action)
      : state;

const reducer = reducerFactory(initialState, handlers);

// Provider component which will be used to wrap a group of components in order to pass context variables
const RootContextProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const value = { state, dispatch };

  return (
    <RootContext.Provider value={value}>{props.children}</RootContext.Provider>
  );
};

// Consumer is the old way of handling context. Using useContext() hook is recommended now.
// const RootContextConsumer = RootContext.Consumer;

export { RootContext, RootContextProvider };
